import { createStore } from 'vuex';
import { SidebarToggle } from './modules/sidebarToggle';
import { UserDetails } from './modules/userData';
import { Customizations } from './modules/customizations';
import { Search } from './modules/search';
import { Booking } from './modules/booking';
import { Provider } from './modules/provider';

export default createStore({
  state: {
  },
  modules: {
    SidebarToggle,
    UserDetails,
    Booking,
    Customizations,
    Search,
    Provider
  },
  mutations: {},
  actions: {}
})
